module.exports = __webpack_public_path__ + "static/media/gallery-leaf-2.9e99054b.svg";